'use strict';

angular.module('ClinicApp').directive('profilePhoto', function(OCPhotoUtil) {
  return {
    restrict: 'A',
    scope: {
      imageData: '=profilePhoto',
      imageSize: '@',
      isInsurance: '=',
    },
    link: function(scope, el, attrs) {
      scope.$watch('imageData', function(data) {
        if (!data) {
          if (el.is('img')) {
            attrs.$set('src', '');
            attrs.$set('alt', '');
          } else {
            el.css('background-image', '');
          }
        } else {
          var size = scope.imageSize || '300x300';
          var imageUrl = scope.isInsurance
            ? OCPhotoUtil.insurancePhotoUrl(data)
            : OCPhotoUtil.getS3ImageUrl(data, size);

          if (el.is('img')) {
            attrs.$set('src', imageUrl);
            attrs.$set('alt', data.description);
          } else {
            el.css('background-image', 'url(' + imageUrl + ')');
            el.css('background-size', 'cover');
          }
        }
      });
    },
  };
});
